import { render, staticRenderFns } from "./PropertyTreeDialog.vue?vue&type=template&id=6b15ef6c&scoped=true&"
import script from "./PropertyTreeDialog.vue?vue&type=script&lang=js&"
export * from "./PropertyTreeDialog.vue?vue&type=script&lang=js&"
import style0 from "./PropertyTreeDialog.vue?vue&type=style&index=0&id=6b15ef6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b15ef6c",
  null
  
)

export default component.exports